<mat-progress-bar 
    #progress 
    [mode]="progressType" 
    [ngClass]="{'mat-progress-bar': true, 
                'hide': show == false }"
    >
</mat-progress-bar>
